$(document).on("turbolinks:load", function () {
  // Check the stored state on page load
  let currentPath = window.location.pathname;

  if (localStorage.getItem("dropdownExpanded") === "true") {
    if (
      currentPath.includes("/system_admin/campaigns") ||
      /\/students\/[^\/]+\/pitches\/[^\/]+/.test(currentPath)
    ) {
      $(".campaigns-dropdown").addClass("show-more");
    }
    $("#show-more-icon").hide();
    $("#show-less-icon").show();
  }

  $("#campaigns-dropdown-button").click(function (e) {
    e.preventDefault();
    $(".campaigns-dropdown").toggleClass("show-more");
    if ($(".campaigns-dropdown").is(":visible")) {
      // $('#show-more-icon').removeClass('icon-visible')
      $("#show-more-icon").hide();
      $("#show-less-icon").show();
      localStorage.setItem("dropdownExpanded", "true");
    } else {
      $("#show-less-icon").hide();
      $("#show-more-icon").show();
      localStorage.setItem("dropdownExpanded", "false");
    }
  });

  if (localStorage.getItem("dropdownAdminExpanded") === "true") {
    if (currentPath.includes("/system_admin/campaigns")) {
      $(".campaigns-dropdown").addClass("show-more");
    }
    $(".campaigns-dropdown-admin").addClass("show-more");
    $("#show-more-icon-admin").hide();
    $("#show-less-icon-admin").show();
  }

  $("#campaigns-dropdown-button-admin").click(function (e) {
    e.preventDefault();
    $(".campaigns-dropdown-admin").toggleClass("show-more");
    if ($(".campaigns-dropdown-admin").is(":visible")) {
      $("#show-more-icon-admin").hide();
      $("#show-less-icon-admin").show();
      localStorage.setItem("dropdownAdminExpanded", "true");
    } else {
      $("#show-less-icon-admin").hide();
      $("#show-more-icon-admin").show();
      localStorage.setItem("dropdownAdminExpanded", "false");
    }
  });
});
